import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SelectInput } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import {
  CONTRACT_TYPE_OPTIONS,
  ContractType,
} from '@/pages/instruments/new-instrument/constants/contract-types'

export interface ContractTypeFieldProps {}

export const ContractTypeField: React.FC<ContractTypeFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ contract_type: ContractType }>()

  return (
    <FormField
      name="contract_type"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Contract Type</FormLabel>
              <FormError />
            </div>
            <SelectInput
              className={'flex flex-1 min-w-auto! w-full'}
              value={value?.toString()}
              onValueChange={(value) =>
                setValue('contract_type', value as ContractType, { shouldValidate: true })
              }
              placeholder={'Select a contract type'}
              options={CONTRACT_TYPE_OPTIONS}
            />
          </FormItem>
        )
      }}
    />
  )
}
